// NGRX
import { createFeatureSelector } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
// Actions
import {
  ContactRelationshipAgreementActions,
  ContactRelationshipAgreementActionTypes,
} from '../_actions/contact-relationship-agreements.actions';
// Models
import { ContactRelationshipAgreementModel } from '../_models/contact-relationship-agreement.model';
import { QueryParamsModel } from '../../_base/crud';

export interface ContactRelationshipAgreementState
  extends EntityState<ContactRelationshipAgreementModel> {
  contactId: number;
  loading: boolean;
  actionsloading: boolean;
  totalCount: number;
  lastQuery: QueryParamsModel;
  showInitWaitingMessage: boolean;
  error: any | null;
  latestSuccessfullAction: any;
}

export const adapter: EntityAdapter<ContactRelationshipAgreementModel> =
  createEntityAdapter<ContactRelationshipAgreementModel>();

export const initialContactRelationshipsState: ContactRelationshipAgreementState =
  adapter.getInitialState({
    loading: false,
    actionsloading: false,
    totalCount: 0,
    contactId: undefined,
    lastCreatedContactRelationshipAgreementsId: undefined,
    lastQuery: new QueryParamsModel({}),
    showInitWaitingMessage: true,
    latestSuccessfullAction: null,
    error: null,
  });

export function contactRelationshipAgreementsReducer(
  state = initialContactRelationshipsState,
  action: ContactRelationshipAgreementActions,
): ContactRelationshipAgreementState {
  switch (action.type) {
    case ContactRelationshipAgreementActionTypes.ContactRelationshipAgreementsPageToggleLoading:
      return {
        ...state,
        loading: action.payload.isLoading,
      };
    case ContactRelationshipAgreementActionTypes.ContactRelationshipAgreementActionToggleLoading: {
      return {
        ...state,
        actionsloading: action.payload.isLoading,
      };
    }
    case ContactRelationshipAgreementActionTypes.ContactRelationshipAgreementsPageRequested:
      return {
        ...state,
        totalCount: 0,
        loading: true,
        contactId: action.payload.contactId,
      };
    case ContactRelationshipAgreementActionTypes.ContactRelationshipAgreementsPageLoaded:
      return adapter.addMany(action.payload.contactRelationshipAgreements, {
        ...initialContactRelationshipsState,
        totalCount: action.payload.totalCount,
        loading: false,
        contactId: state.contactId,
        lastQuery: state.lastQuery,
        showInitWaitingMessage: false,
      });
    case ContactRelationshipAgreementActionTypes.ThrowContactRelationshipAgreementError: {
      return {
        ...state,
        error: action.payload.error,
        actionsloading: false,
        loading: false,
      };
    }
    case ContactRelationshipAgreementActionTypes.ClearContactRelationshipAgreementErrors: {
      return {
        ...state,
        error: null,
      };
    }
    case ContactRelationshipAgreementActionTypes.ClearContactRelationshipAgreementState: {
      return initialContactRelationshipsState;
    }
    default:
      return state;
  }
}

export const getcontactRelationshipAgreementsState =
  createFeatureSelector<ContactRelationshipAgreementModel>('contactRelationshipAgreements');

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
